import axios from "axios";

export const getFactoryFabricDropdown = async (supplier_master_id) => {
  try {
    const config = {
      withCredentials: true,
      headers: {
        withCredentials: true,
      },
    };
    const data = await axios.get(
      `${process.env.REACT_APP_URL}/api/list/kfc-list-with-factory-fabric`,
      config
    );
    return data?.data?.result;
  } catch (error) {
    console.log(error);
    return error;
    // return error?.response?.data?.result;
  }
};
